module.exports = __webpack_public_path__ + "img/upload.194d5d35.svg";